<template>
  <div 
    class="timecodes" 
    :style="timecodesStyles" 
    :class="{ 'timecodes--top': !isAtTop, 'timecodes--bottom': !isAtBottom }"
  >
    <div 
      class="timecodes__scroll-box" 
      ref="scrollContainer"
      :style="`max-height: ${props.height}px;`"
      @scroll="handleScroll"
    >
      <TimecodeItem
        class="timecodes__item" 
        v-for="(title, time) in timecodes"
        :isActive="isThePodcastActive && (time == currentTimecodeId)"
        :text="title"
        :ref="el => setActiveTimecodeRef(el, time)"
        :time="formatSeconds_h_min_s(time)"
        @click="seekToTime(time, props.idPodcast)"
      />
    </div>
  </div>
</template>

<script setup>
  import { Props } from './props';
  import { useStore } from 'vuex';
  import { ref, onMounted, onUnmounted, computed, nextTick } from 'vue';
  import { formatSeconds_h_min_s } from '@shared/utils/time/secondFormated.js';
  import { useAudioControl } from '../../composables/audioControl';
  import { useAudioPlayerState } from '../../composables/computedValues';
  //--------------------------------
  import TimecodeItem from '../../ui/TimecodeItem/TimecodeItem.vue';
  //--------------------------------
  const props = defineProps(Props());
  const store = useStore();
  //--------------------------------
  const scrollContainer = ref(null);
  const isAtTop = ref(true);
  const isAtBottom = ref(false);
  const activeTimecode = ref(null);
  //--------------------------------
  let scrollThrottleTimeout = null;
  //--------------------------------
  const timecodes = store.state.Audioplayer.list[props.idPodcast].timecodes;
  //--------------------------------
  const { seekToTime } = useAudioControl();
  //--------------------------------
  const { podcast, currentTimecodeId } = useAudioPlayerState();
  //--------------------------------
  onMounted(() => {
    checkScrollPosition();
    window.addEventListener('resize', checkScrollPosition);
    nextTick(() => {
      if (activeTimecode.value && scrollContainer.value) {
        scrollContainer.value.scrollTop = activeTimecode.value.offsetTop - 50;
      }
    });
  });
  onUnmounted(() => {
    window.removeEventListener('resize', checkScrollPosition);
  });
  //--------------------------------
  //Это текущий таймкод
  const isThePodcastActive = computed(() => {
    return podcast.value.id == props.idPodcast;
  });
  //Стили для таймкодов
  const timecodesStyles = computed(() => {
    return { '--gradient': props.gradient };
  });
  //--------------------------------
   //Запомнить ref активного таймкода
  const setActiveTimecodeRef = (el, time) => {
    if (time == currentTimecodeId.value) {
      activeTimecode.value = el?.$el || el;
    }
  };
  //Проверка позиции скролла
  const checkScrollPosition = () => {
    if (!scrollContainer.value) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollContainer.value;
    const threshold = 5;
    isAtTop.value = scrollTop <= threshold;
    isAtBottom.value = scrollHeight - (scrollTop + clientHeight) <= threshold;
  };
  //Действия при скролле
  const handleScroll = () => {
    if (scrollThrottleTimeout) return;
    scrollThrottleTimeout = setTimeout(() => {
      checkScrollPosition();
      scrollThrottleTimeout = null;
    }, 300);
  };
</script>

<style scoped lang="scss">
  @import "./styles.scss";
</style>